import { jsx as _jsx } from "react/jsx-runtime";
import { ShowBase } from "react-admin";
import { CandidateTabs } from "./CandidateTabs";
export var CandidateBaseTabs = function () {
    return (_jsx(ShowBase, { children: _jsx(CandidateTabs, {}) }));
};
